import React, { useContext } from "react";
import { Alert, AlertDescription } from "@jem-open/jem-ui";
import { Monitor } from "lucide-react";
import { AuthContext } from "../../providers/AuthProvider";
import UserAccessControlUtils, {
  FEATURE_TIME_AND_ATTENDANCE,
} from "../../utils/UserAccessControlUtils";

const DesktopOnlyBanner: React.FC = () => {
  const auth = useContext(AuthContext);
  const hasTimeAttendance = UserAccessControlUtils.hasFeature(
    auth?.user_features || [],
    FEATURE_TIME_AND_ATTENDANCE
  );

  return (
    <Alert
      variant="note"
      className="sm:hidden mb-md !flex-row items-center gap-sm"
      hideIcon
    >
      <Monitor size={16} className="text-primary-navy-600 shrink-0" />
      <div className="flex-1">
        <p className="font-semibold text-sm text-greyscale-text-title leading-tight">
          Desktop-only feature
        </p>
        <AlertDescription className="pl-0 text-xs">
          {hasTimeAttendance
            ? "View on a larger screen for the full experience. Time & Attendance is the only feature currently optimised for mobile."
            : "View on a larger screen for the full Jem Hub experience."}
        </AlertDescription>
      </div>
    </Alert>
  );
};

export default DesktopOnlyBanner;
